export { initI18n } from './initI18n';
export {
  t,
  translate,
  toI18nMessage,
  isI18nMessage,
  DEFAULT_ARDOQ_I18NLOCALE,
} from './t';
export type { I18nLocale, I18nMessage, WithI18nLocale } from './t';
export {
  registerMissingKeyReporter,
  registerBrokenInterpolationReporter,
  reportBrokenInterpolation,
} from './missingKeyReporter';
export type {
  MissingKeyReporter,
  MissingTranslationKey,
  BrokenInterpolation,
  BrokenInterpolationReporter,
} from './missingKeyReporter';

// locale$ and t$ are intentionally NOT re-exported from the main entry
// point. Importing them triggers eager RxJS module evaluation which
// breaks jest tests that import @ardoq/i18n before i18next is initialized.
// Import them directly when needed:
//   import { locale$ } from '@ardoq/i18n/src/locale$';
//   import { t$ } from '@ardoq/i18n/src/t$';

export { useTranslation, Trans } from 'react-i18next';
import i18n from 'i18next';

// Keeps i18next in sync with the app's authoritative language source (locale$).
// Call this from within your locale$ pipeline — not as a standalone write path —
// so that i18next always follows the stream, never the other way around. E.g.:
//   locale$.pipe(tap(({ language }) => changeLanguage(language))).subscribe()
// This ensures useTranslation() / Trans re-render when the language changes.
export const changeLanguage = (lng: string): Promise<string> =>
  i18n.changeLanguage(lng).then(() => lng);
